import { useState } from 'react'
import type { NextLevelProps } from '../../../global-navigation'
import { AlphabeticalMenuItems } from './AlphabeticalMenuItems'
import { Search } from './Search'

export const AlphabeticalMenu = ({ menu }: NextLevelProps) => {
  const [query, setQuery] = useState('')

  return (
    <div
      className={`w-[360px] h-screen navigation-panel-step active`}
      data-category={menu?.title}
    >
      <div className="px-6 pt-10 pb-4 mb-3">
        <div className="px-3 min-h-[32px]">
          <p
            style={{ color: menu?.titleColor ? menu.titleColor : '#0A0A0A' }}
            className="font-bold text-2xl tracking-[-0.48px]"
          >
            {menu?.title}
          </p>
        </div>
        <Search setQuery={setQuery} />
        <div className="px-3 pt-3 space-y-3">
          {menu && <AlphabeticalMenuItems menu={menu} query={query} />}
        </div>
      </div>
    </div>
  )
}
